import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is LineupSync a free team management app?",
    a: "Yes. The free plan covers one team with unlimited players and staff, including scheduling, automatic RSVPs, the roster and the lineup builder. Pro is 9 EUR per team per month and adds stats, chat, AI lineup suggestions and no ads.",
  },
  {
    q: "Who is it for?",
    a: "One coach or manager running a Sunday league side, a rec team or a small youth club. If you need registration, subs collection and league admin, a club platform like TeamSnap or Spond fits better.",
  },
  {
    q: "How do the automatic RSVPs work?",
    a: "When you create an event everyone gets a request by email. They answer in one tap without logging in, and anyone who has not replied gets a reminder before the deadline you set.",
  },
  {
    q: "Do players need an account?",
    a: "Not to answer an event. They only create one if they want the full app, and that takes about half a minute from the invite link.",
  },
  {
    q: "How does the lineup builder work?",
    a: "Pick a formation, then drag players onto the pitch. By default only the players who said they are coming appear on the bench. There is also a free version at /lineup-builder that needs no account at all.",
  },
  {
    q: "What sports does it work for?",
    a: "Scheduling, RSVPs and the roster work for any team sport. Formation presets currently cover football, from 5 a side to 11 a side.",
  },
  {
    q: "Can I run more than one team?",
    a: "Yes. You can switch between teams from one account, and the Club plan puts several teams under one dashboard.",
  },
  {
    q: "Is my team data private?",
    a: "Teams are private by default. You can turn on a public team page showing your schedule, results and roster if you want one, and contact details are never shown to other players.",
  },
];

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-display text-3xl md:text-5xl font-bold mb-4"
          >
            Frequently asked questions
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-border/60 rounded-xl px-6 data-[state=open]:bg-muted/30"
              >
                <AccordionTrigger className="text-left font-medium hover:no-underline py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
